import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { PreviewWithDataErrorMessage } from '../../common/types';

export interface WebPushPreviewContextState {
  isLoading: boolean;
  messageContentBody: string;
  messageContentTitle: string;
  messageContentClickAction: string;
  previewError?: PreviewWithDataErrorMessage;
  onRefreshPreview: NoOp;
  isPreviewWithData: boolean;
}

export const WebPushPreviewContext = createContext<WebPushPreviewContextState>({
  isLoading: false,
  messageContentBody: '',
  messageContentTitle: '',
  messageContentClickAction: '',
  previewError: undefined,
  onRefreshPreview: noop,
  isPreviewWithData: false,
});

export const useWebPushPreviewContext = () => useContext(WebPushPreviewContext);
